import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getFailedToFetchReports } from '../common/errorMessages';
import { STUDENT_ANALYSES } from '@instructure/quiz-common';
export var fetchReportStatus = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var activeQuizId, addError, fetchAnalysesStatus, instrumentedFetchReports, setStatusPollingInProgress, setGenerationInProgress, status, isReportGenerationReady;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          activeQuizId = _ref.activeQuizId, addError = _ref.addError, fetchAnalysesStatus = _ref.fetchAnalysesStatus, instrumentedFetchReports = _ref.instrumentedFetchReports, setStatusPollingInProgress = _ref.setStatusPollingInProgress, setGenerationInProgress = _ref.setGenerationInProgress;
          _context.prev = 1;
          _context.next = 4;
          return fetchAnalysesStatus(activeQuizId, 'last_attempt', STUDENT_ANALYSES);
        case 4:
          status = _context.sent;
          isReportGenerationReady = !status.student_analyses_in_progress;
          if (isReportGenerationReady) {
            instrumentedFetchReports();
            setStatusPollingInProgress(false);
            setGenerationInProgress(false);
          }
          return _context.abrupt("return", isReportGenerationReady);
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](1);
          addError(getFailedToFetchReports());
          setStatusPollingInProgress(false);
          setGenerationInProgress(false);
          return _context.abrupt("return", true);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 10]]);
  }));
  return function fetchReportStatus(_x) {
    return _ref2.apply(this, arguments);
  };
}();